<template>
    <div class="row">
        <div class="col-12">
            <ul class="nav nav-pills nav-justified py-3" id="homeNavPills" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="quote-tab" data-bs-toggle="tab" href="#quote" role="tab"
                       aria-controls="quote" aria-selected="true">{{lang('quote')}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="application-tab" data-bs-toggle="tab" href="#application" role="tab"
                       aria-controls="application" aria-selected="false">{{lang('application')}}</a>
                </li>
            </ul>
            <div class="tab-content" id="homeNavPillsContent">
                <div class="tab-pane fade show active" id="quote" role="tabpanel" aria-labelledby="quote-tab">
                    <div id="accordionOne">
                        <div id="saved_quotes" class="card">
                            <div class="card-header cursorPointer" @click="toggleSection(saved_quotes_block)"
                                 :id="`heading_saved_quote`" data-bs-toggle="collapse" :data-bs-target="`#collapse_saved_quote`"
                                 aria-expanded="true" :aria-controls="`collapse_saved_quote`">
                                <h5 class="mb-0">
                                    <span v-if="saved_quotes_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                    <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                    <span>{{lang('your_saved_quotes')}}</span>
                                </h5>
                            </div>
                            <div data-bs-parent="#accordionOne" id="collapse_saved_quote" :aria-labelledby="`heading_saved_quote`" class="collapse card-body">
                                <div v-if="saved_quotes.length > 0">
                                    <dashboard-card v-for="(quote, index) in saved_quotes"
                                                    :key="index"
                                                    :is-view="false"
                                                    :title="quote.merchant_name"
                                                    :entity="quote"
                                                    :url="getSavedQuotePath(quote)"
                                                    :status="formatQuoteStatus(quote)"
                                    ></dashboard-card>
                                </div>
                                <div v-else class="row">
                                    <div class="col-12">
                                        <np-notice :dismissable="false" :notice="lang('no_quotes_found')"></np-notice>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="previous_quotes" class="card">
                            <div class="card-header cursorPointer" @click="toggleSection(previous_quotes_block)"
                                 :id="`heading_previous_quotes_block`" data-bs-toggle="collapse" :data-bs-target="`#collapse_previous_quotes_block`"
                                 aria-expanded="true" :aria-controls="`collapse_previous_quotes_block`">
                                <h5 class="mb-0">
                                    <span v-if="previous_quotes_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                    <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                    <span>{{lang('your_previous_quotes')}}</span>
                                </h5>
                            </div>
                            <div data-bs-parent="#accordionOne" id="collapse_previous_quotes_block" :aria-labelledby="`heading_previous_quotes_block`" class="collapse card-body">
                                <div v-if="previous_quotes.length > 0">
                                    <dashboard-card v-for="(quote, index) in previous_quotes"
                                                    :key="index"
                                                    :is-view="true"
                                                    :title="quote.merchant_name"
                                                    :entity="quote"
                                                    :url="getPreviousQuotePath(quote)"
                                                    :status="formatQuoteStatus(quote)"
                                    ></dashboard-card>
                                </div>
                                <div v-else class="row">
                                    <div class="col-12">
                                        <np-notice :dismissable="false" :notice="lang('no_quotes_found')"></np-notice>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="application" role="tabpanel" aria-labelledby="application-tab">
                    <div id="accordionTwo">
                        <div id="saved_applications" class="card">
                            <div class="card-header cursorPointer" @click="toggleSection(saved_applications_block)"
                                 :id="`heading_saved_application`" data-bs-toggle="collapse" :data-bs-target="`#collapse_saved_application`"
                                 aria-expanded="true" :aria-controls="`collapse_saved_application`">
                                <h5 class="mb-0">
                                    <span v-if="saved_applications_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                    <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                    <span>{{lang('your_saved_applications')}}</span>
                                </h5>
                            </div>
                            <div data-bs-parent="#accordionTwo" id="collapse_saved_application" :aria-labelledby="`heading_saved_application`" class="collapse card-body">
                                <div v-if="saved_applications.length > 0">
                                    <dashboard-card v-for="(application, index) in saved_applications"
                                                    :key="index"
                                                    :is-view="false"
                                                    :title="application.legal_name"
                                                    :entity="application"
                                                    :url="getSavedApplicationPath(application)"
                                                    :status="formatApplicationStatus(application)"
                                    ></dashboard-card>
                                </div>
                                <div v-else class="row">
                                    <div class="col-12">
                                        <np-notice :dismissable="false" :notice="lang('no_applications_found')"></np-notice>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="submitted_applications" class="card">
                            <div class="card-header cursorPointer" @click="toggleSection(submitted_applications_block)"
                                 :id="`heading_submitted_applications_block`" data-bs-toggle="collapse" :data-bs-target="`#collapse_submitted_applications_block`"
                                 aria-expanded="true" :aria-controls="`collapse_submitted_applications_block`">
                                <h5 class="mb-0">
                                    <span v-if="submitted_applications_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                    <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                    <span>{{lang('your_submitted_applications')}}</span>
                                </h5>
                            </div>
                            <div data-bs-parent="#accordionTwo" id="collapse_submitted_applications_block" :aria-labelledby="`heading_submitted_applications_block`" class="collapse card-body">
                                <div v-if="submitted_applications.length > 0">
                                    <dashboard-card v-for="(application, index) in submitted_applications"
                                                    :key="index"
                                                    :is-view="true"
                                                    :title="application.legal_name"
                                                    :entity="application"
                                                    :url="getSubmittedApplicationPath(application)"
                                                    :reference="application.reference"
                                                    :status="formatApplicationStatus(application)"
                                    ></dashboard-card>
                                </div>
                                <div v-else class="row">
                                    <div class="col-12">
                                        <np-notice :dismissable="false" :notice="lang('no_applications_found')"></np-notice>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DashboardCard from "../../components/dashboard-card.vue";
    import {NPNotice} from "../../netpify/components"
    import {mapState} from "pinia";
    import useModuleStore from "../../stores";

    export default {
        name: "dashboard",
        components: {DashboardCard, 'np-notice': NPNotice},
        data() {
            return {
                saved_quotes_block: {
                    is_open: false,
                },
                previous_quotes_block: {
                    is_open: false,
                },
                saved_applications_block: {
                    is_open: false,
                },
                submitted_applications_block: {
                    is_open: false,
                },
                quote_statuses: {
                    '1': 'Initiated',
                    '2': 'Generated',
                    '3': 'Accepted',
                    '4': 'Converted',
                },
            }
        },
        computed: {
            ...mapState(useModuleStore,{
                merchant_user_access:'merchant_user_access',
                dashboard:'dashboard',
                parameters:'parameters'}),
            saved_quotes: function () {
                // return this.merchant_user_access.quote.filter(obj => obj.status_id === '1')
                return this.dashboard.saved.hasOwnProperty('quotes') &&
                this.objectIsNotEmpty(this.dashboard.saved.quotes) ? this.dashboard.saved.quotes : [];
            },
            previous_quotes: function () {
                // return this.merchant_user_access.quote.filter(obj => obj.status_id === '4')
                return this.dashboard.recent.hasOwnProperty('quotes') &&
                this.objectIsNotEmpty(this.dashboard.recent.quotes) ? this.dashboard.recent.quotes : [];
            },
            saved_applications: function (){
                return this.dashboard.saved.hasOwnProperty('applications') &&
                this.objectIsNotEmpty(this.dashboard.saved.applications) ? this.dashboard.saved.applications : [];
            },
            submitted_applications: function (){
                return this.dashboard.recent.hasOwnProperty('applications') &&
                this.objectIsNotEmpty(this.dashboard.recent.applications) ? this.dashboard.recent.applications : [];
            },
        },
        methods:{
            toggleSection: function (section){
                section.is_open = !section.is_open
            },
            formatQuoteStatus: function (quote){
                return this.quote_statuses.hasOwnProperty(quote.status_id) ? this.quote_statuses[quote.status_id] : '';
            },
            formatApplicationStatus(application) {
                let status = application.application_status_external_id;
                return  this.formatSelectType(this.parameters, status, 'APPLICATION_STATUS_PARAM');
            },
            getSavedQuotePath: function (quote){
                return `/quote/edit/${quote.quote_external_id}/business/`;
            },
            getPreviousQuotePath: function (quote){
                return `/quote/view/${quote.quote_external_id}/business/`;
            },
            getSavedApplicationPath: function (application) {
                return `/application/edit/${application.application_reference}/business_details/`;
            },
            getSubmittedApplicationPath: function (application){
                return `/application/view/${application.application_reference}/business_details/`;
            },
        }
    }
</script>

<style scoped>

</style>
